import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import '../UpdateProject.css';
import ResultPageComponent from 'src/modules/commons/result-page/ResultPage.Component';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';
import * as moment from 'moment';
import CompanyData from 'src/value-objects/CompanyData';
import CountrySelectComponent from 'src/modules/commons/inputs/country-select/CountrySelect.component';
import Datepicker from 'src/modules/commons/datepicker/Datepicker.component';

export interface Props {
  formData: CompanyData;
  error: boolean;
  errorMessage: {};
  success: boolean;
  handleChange(key: string): (value: string | boolean | File | moment.Moment) => void;
  handleSubmit(): void;
}

class ProjectContactInformationFormComponent extends React.PureComponent<Props> {

  public render(): React.ReactNode {
    return (
      <div className="tab-content padding-40">
        {!this.props.success ?
          <div className="content">
            <p>
              <strong>
                Los datos que introduzcas deberán ser los mismos que aparecen en tu NIF o NIE:
              </strong>
            </p>
            <p className="question-detail">
              Recuerda, los campos marcados con * son obligatorios
            </p>
            <div className="gap-20"/>
            <div className="row">
              <div className="col-sm-6 col-md-4">
                <div className="md-input">
                  <InputContainer
                    label="Nombre"
                    type="text"
                    value={this.props.formData.contactName || ''}
                    onChange={(value) => this.props.handleChange('contactName')(value)}
                    required={true}
                  />
                </div>
                <div className="gap-20"/>
              </div>
              <div className="col-sm-6 col-md-4">
                <div className="md-input">
                  <InputContainer
                    label="Apellido/s"
                    type="text"
                    value={this.props.formData.contactSurname || ''}
                    onChange={(value) => this.props.handleChange('contactSurname')(value)}
                    required={true}
                  />
                </div>
                <div className="gap-20"/>
              </div>
              <div className="col-sm-6 col-md-4">
              <CountrySelectComponent
                value={this.props.formData.contactNationality}
                required={true}
                label={'Nacionalidad'}
                onChange={this.props.handleChange('contactNationality')}
              />
                <div className="gap-20"/>
              </div>
              <div className="col-sm-6 col-md-4">
                <div className="gap-20"/>
                <div className="md-input">
                  <InputContainer
                    label="NIF o NIE"
                    type="text"
                    value={this.props.formData.contactNif || ''}
                    onChange={(value) => this.props.handleChange('contactNif')(value)}
                    required={true}
                  />
                </div>
                <div className="gap-20"/>
              </div>
              <div className="col-sm-6 col-md-4 date-group">
                <Datepicker
                  label="Fecha de nacimiento"
                  required={true}
                  value={this.props.formData.contactBirthDate}
                  handleChange={this.props.handleChange('contactBirthDate')}
                />
              </div>
              <div className="col-sm-6 col-md-4">
                <div className="gap-20"/>
                <div className="md-input">
                  <InputContainer
                    label="Email de usuario"
                    type="text"
                    required={true}
                    value={this.props.formData.contactEmail || ''}
                    onChange={(value) => this.props.handleChange('contactEmail')(value)}
                  />
                </div>
                <div className="gap-20"/>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-4">
                <div className="md-input">
                  <InputContainer
                    label="Teléfono móvil"
                    type="text"
                    required={true}
                    value={this.props.formData.contactPhoneNumber || ''}
                    onChange={(value) => this.props.handleChange('contactPhoneNumber')(value)}
                  />
                </div>
                <div className="gap-20"/>
              </div>
              <div className="col-sm-6 col-md-4">
                <div className="md-input">
                  <InputContainer
                    label="Dirección"
                    type="text"
                    required={true}
                    value={this.props.formData.contactAddress || ''}
                    onChange={(value) => this.props.handleChange('contactAddress')(value)}
                  />
                </div>
                <div className="gap-20"/>
              </div>
              <div className="col-sm-6 col-md-4">
                <div className="md-input">
                  <InputContainer
                    label="Código postal"
                    type="text"
                    required={true}
                    value={this.props.formData.contactZipCode || ''}
                    onChange={(value) => this.props.handleChange('contactZipCode')(value)}
                  />
                </div>
                <div className="gap-20"/>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-4">
                <div className="md-input">
                  <InputContainer
                    label="Ciudad"
                    type="text"
                    required={true}
                    value={this.props.formData.contactCity || ''}
                    onChange={(value) => this.props.handleChange('contactCity')(value)}
                  />
                </div>
                <div className="gap-20"/>
              </div>
              <div className="col-sm-6 col-md-4">
                <div
                  className="md-input"
                >
                  <InputContainer
                    label="Provincia"
                    type="text"
                    required={true}
                    value={this.props.formData.contactProvince || ''}
                    onChange={(value) => this.props.handleChange('contactProvince')(value)}
                  />
                </div>
                <div className="gap-20"/>
              </div>
              <div className="col-sm-6 col-md-4">
                <div className="md-input">
                  <CountrySelectComponent
                    value={this.props.formData.contactCountry}
                    required={true}
                    onChange={this.props.handleChange('contactCountry')}
                  />
                </div>
                <div className="gap-20"/>
              </div>
            </div>
            <div className="gap-20"/>
          </div> :
          <div className="content">
            <ResultPageComponent
              title="Los datos de contacto se han guardado correctamente"
              message=""
              success={true}
            />
          </div>
        }
        {!this.props.success ?
          <div>
            <div className="text-right">
              <button
                type="button"
                className="btn btn-primary"
                data-container="body"
                data-html="true"
                data-toggle="popover"
                data-placement="bottom"
                onClick={(e) => this.props.handleSubmit()}
              >
                Guardar
              </button>
              <div className="gap-20"/>
              <ErrorMessagesComponent
                errorMessage={this.props.errorMessage}
              />
            </div>
            {/*TODO*/}
            {/*<p className="text-center">
              <button
                className="btn btn-secondary btn-lg"
                onClick={() => { return; }}
              >
                Enviar para revisión
              </button>
            </p>*/}
            <div className="gap-20"/>
          </div>
          : null
        }
        <div className="gap-20"/>
      </div>
    );
  }
}

export default ProjectContactInformationFormComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/ProjectContactInformationForm.component.tsx